import { apiService } from './api';
import { ApiResponse } from '../types';

export type PlatformConfigMap = Record<string, string>;

class PlatformConfigService {
  async getPlatformConfig(): Promise<PlatformConfigMap> {
    const response: ApiResponse<PlatformConfigMap> = await apiService.get('/api/admin/config/platform');
    return response.payload || {};
  }

  async updatePlatformConfig(configs: PlatformConfigMap): Promise<PlatformConfigMap> {
    const response: ApiResponse<PlatformConfigMap> = await apiService.put('/api/admin/config/platform', configs);
    return response.payload || {};
  }
}

export const platformConfigService = new PlatformConfigService();
export default platformConfigService;
